<div class="summary">
  <ng-container
    *ngIf="bookingStore.selectedInstallationsCount$ | async as installationsCount; else emptyCart"
  >
    <h3 class="summary-title">{{ '+BOOKING.SUMMARY.SHOPPING_CART' | translate }}</h3>
    <div class="summary-cart">
      <div class="cart-entry">
        <span data-at-selected-package="Pro">{{ '+BOOKING.SUMMARY.PLAN.PRO' | translate }}</span>
        <span>{{ installationsCount }} x {{ voucherPrice }} {{ currency }}</span>
      </div>
    </div>
    <div
      *ngIf="(bookingStore.subscriptionsDetails$ | async)?.price as price"
      class="summary-discounts"
    >
      <div class="discounts-entry">
        <span>{{ '+BOOKING.PRICE.TAX_RATE' | translate: { taxRate: price.taxRate } }}</span
        ><span data-at-tax class="discounts-entry-price"
          >{{ voucherPrice }} {{ price.currency }}</span
        >
      </div>
    </div>

    <div class="summary-br"></div>
    <div class="summary-total-price">{{ voucherPrice }} {{ currency }}</div>

    <div class="summary-tos" *ngIf="isCheckout && document">
      <mat-checkbox
        data-at-terms-of-use-checkbox
        gtm="onToggle"
        gtmAction="Booking Checkout"
        gtmCategory="booking"
        [(ngModel)]="tosAccepted"
        (ngModelChange)="onTosCheckboxChange($event)"
      >
      </mat-checkbox>
      <span
        [innerHTML]="
          '+BOOKING.SUMMARY_USER_AGGREEMENT.TEXT'
            | translate
            | link: '{key}':'+BOOKING.SUMMARY_USER_AGGREEMENT.KEY_TRANSLATION':document.link
        "
      ></span>
    </div>
  </ng-container>

  <button
    data-at-checkout-button
    gtm="onGoToPage"
    gtmAction="Booking Checkout"
    gtmCategory="booking"
    class="summary-btn-continue"
    [disabled]="isContinueDisabled()"
    mat-raised-button
    color="primary"
    (click)="onContinue()"
  >
    <span *ngIf="!isCheckout">{{
      '+BOOKING.SUMMARY.CONTINGENT_SUBSCRIPTIONS.CONTINUE_BTN' | translate
    }}</span>
    <span *ngIf="isCheckout">{{
      '+BOOKING.SUMMARY.CONTINGENT_SUBSCRIPTIONS.ASSIGN_BTN' | translate
    }}</span>
  </button>

  <ng-template #emptyCart>
    <h3 class="summary-title">{{ '+BOOKING.SUMMARY_EMPTY_CART.TITLE' | translate }}</h3>
    <div class="summary-description">
      {{ '+BOOKING.SUMMARY_EMPTY_CART.DESCRIPTION' | translate }}
    </div>
  </ng-template>
</div>
